/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function(){ return this }).call(null);

goog.exportSymbol('proto.ExchangeAddress', null, global);
goog.exportSymbol('proto.ExchangeResponse', null, global);
goog.exportSymbol('proto.ExchangeResponseV2', null, global);
goog.exportSymbol('proto.SignedExchangeResponse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ExchangeAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ExchangeAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ExchangeAddress.displayName = 'proto.ExchangeAddress';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ExchangeAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.ExchangeAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ExchangeAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    coinType: jspb.Message.getField(msg, 1),
    address: jspb.Message.getField(msg, 2),
    destTag: jspb.Message.getField(msg, 3),
    rsAddress: jspb.Message.getField(msg, 4)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ExchangeAddress}
 */
proto.ExchangeAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ExchangeAddress;
  return proto.ExchangeAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ExchangeAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ExchangeAddress}
 */
proto.ExchangeAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoinType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestTag(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRsAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ExchangeAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ExchangeAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ExchangeAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string coin_type = 1;
 * @return {string}
 */
proto.ExchangeAddress.prototype.getCoinType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.ExchangeAddress.prototype.setCoinType = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.ExchangeAddress.prototype.clearCoinType = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeAddress.prototype.hasCoinType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.ExchangeAddress.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.ExchangeAddress.prototype.setAddress = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.ExchangeAddress.prototype.clearAddress = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeAddress.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string dest_tag = 3;
 * @return {string}
 */
proto.ExchangeAddress.prototype.getDestTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.ExchangeAddress.prototype.setDestTag = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.ExchangeAddress.prototype.clearDestTag = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeAddress.prototype.hasDestTag = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string rs_address = 4;
 * @return {string}
 */
proto.ExchangeAddress.prototype.getRsAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.ExchangeAddress.prototype.setRsAddress = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.ExchangeAddress.prototype.clearRsAddress = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeAddress.prototype.hasRsAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ExchangeResponseV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ExchangeResponseV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ExchangeResponseV2.displayName = 'proto.ExchangeResponseV2';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ExchangeResponseV2.prototype.toObject = function(opt_includeInstance) {
  return proto.ExchangeResponseV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ExchangeResponseV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeResponseV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    depositAddress: (f = msg.getDepositAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    depositAmount: msg.getDepositAmount_asB64(),
    expiration: jspb.Message.getField(msg, 3),
    quotedRate: msg.getQuotedRate_asB64(),
    withdrawalAddress: (f = msg.getWithdrawalAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    withdrawalAmount: msg.getWithdrawalAmount_asB64(),
    returnAddress: (f = msg.getReturnAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    apiKey: msg.getApiKey_asB64(),
    minerFee: msg.getMinerFee_asB64(),
    orderId: msg.getOrderId_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ExchangeResponseV2}
 */
proto.ExchangeResponseV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ExchangeResponseV2;
  return proto.ExchangeResponseV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ExchangeResponseV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ExchangeResponseV2}
 */
proto.ExchangeResponseV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setDepositAddress(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDepositAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiration(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setQuotedRate(value);
      break;
    case 5:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setWithdrawalAddress(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setWithdrawalAmount(value);
      break;
    case 7:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setReturnAddress(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setApiKey(value);
      break;
    case 9:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMinerFee(value);
      break;
    case 10:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ExchangeResponseV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ExchangeResponseV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeResponseV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDepositAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getWithdrawalAddress();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getReturnAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBytes(
      8,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBytes(
      9,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBytes(
      10,
      f
    );
  }
};


/**
 * optional ExchangeAddress deposit_address = 1;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponseV2.prototype.getDepositAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 1));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponseV2.prototype.setDepositAddress = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.ExchangeResponseV2.prototype.clearDepositAddress = function() {
  this.setDepositAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasDepositAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes deposit_amount = 2;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getDepositAmount = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes deposit_amount = 2;
 * This is a type-conversion wrapper around `getDepositAmount()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getDepositAmount_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDepositAmount()));
};


/**
 * optional bytes deposit_amount = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDepositAmount()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getDepositAmount_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDepositAmount()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setDepositAmount = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.ExchangeResponseV2.prototype.clearDepositAmount = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasDepositAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 expiration = 3;
 * @return {number}
 */
proto.ExchangeResponseV2.prototype.getExpiration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.ExchangeResponseV2.prototype.setExpiration = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.ExchangeResponseV2.prototype.clearExpiration = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasExpiration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bytes quoted_rate = 4;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getQuotedRate = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes quoted_rate = 4;
 * This is a type-conversion wrapper around `getQuotedRate()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getQuotedRate_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getQuotedRate()));
};


/**
 * optional bytes quoted_rate = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getQuotedRate()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getQuotedRate_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getQuotedRate()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setQuotedRate = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.ExchangeResponseV2.prototype.clearQuotedRate = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasQuotedRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ExchangeAddress withdrawal_address = 5;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponseV2.prototype.getWithdrawalAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 5));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponseV2.prototype.setWithdrawalAddress = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.ExchangeResponseV2.prototype.clearWithdrawalAddress = function() {
  this.setWithdrawalAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasWithdrawalAddress = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bytes withdrawal_amount = 6;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getWithdrawalAmount = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes withdrawal_amount = 6;
 * This is a type-conversion wrapper around `getWithdrawalAmount()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getWithdrawalAmount_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getWithdrawalAmount()));
};


/**
 * optional bytes withdrawal_amount = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getWithdrawalAmount()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getWithdrawalAmount_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getWithdrawalAmount()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setWithdrawalAmount = function(value) {
  jspb.Message.setField(this, 6, value);
};


proto.ExchangeResponseV2.prototype.clearWithdrawalAmount = function() {
  jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasWithdrawalAmount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ExchangeAddress return_address = 7;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponseV2.prototype.getReturnAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 7));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponseV2.prototype.setReturnAddress = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.ExchangeResponseV2.prototype.clearReturnAddress = function() {
  this.setReturnAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasReturnAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bytes api_key = 8;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getApiKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * optional bytes api_key = 8;
 * This is a type-conversion wrapper around `getApiKey()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getApiKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getApiKey()));
};


/**
 * optional bytes api_key = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getApiKey()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getApiKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getApiKey()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setApiKey = function(value) {
  jspb.Message.setField(this, 8, value);
};


proto.ExchangeResponseV2.prototype.clearApiKey = function() {
  jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasApiKey = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bytes miner_fee = 9;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getMinerFee = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * optional bytes miner_fee = 9;
 * This is a type-conversion wrapper around `getMinerFee()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getMinerFee_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMinerFee()));
};


/**
 * optional bytes miner_fee = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMinerFee()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getMinerFee_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMinerFee()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setMinerFee = function(value) {
  jspb.Message.setField(this, 9, value);
};


proto.ExchangeResponseV2.prototype.clearMinerFee = function() {
  jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasMinerFee = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bytes order_id = 10;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponseV2.prototype.getOrderId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * optional bytes order_id = 10;
 * This is a type-conversion wrapper around `getOrderId()`
 * @return {string}
 */
proto.ExchangeResponseV2.prototype.getOrderId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getOrderId()));
};


/**
 * optional bytes order_id = 10;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOrderId()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponseV2.prototype.getOrderId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getOrderId()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponseV2.prototype.setOrderId = function(value) {
  jspb.Message.setField(this, 10, value);
};


proto.ExchangeResponseV2.prototype.clearOrderId = function() {
  jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponseV2.prototype.hasOrderId = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SignedExchangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SignedExchangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.SignedExchangeResponse.displayName = 'proto.SignedExchangeResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SignedExchangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.SignedExchangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SignedExchangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SignedExchangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    response: (f = msg.getResponse()) && proto.ExchangeResponse.toObject(includeInstance, f),
    signature: msg.getSignature_asB64(),
    responsev2: (f = msg.getResponsev2()) && proto.ExchangeResponseV2.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SignedExchangeResponse}
 */
proto.SignedExchangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SignedExchangeResponse;
  return proto.SignedExchangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SignedExchangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SignedExchangeResponse}
 */
proto.SignedExchangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ExchangeResponse;
      reader.readMessage(value,proto.ExchangeResponse.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSignature(value);
      break;
    case 3:
      var value = new proto.ExchangeResponseV2;
      reader.readMessage(value,proto.ExchangeResponseV2.deserializeBinaryFromReader);
      msg.setResponsev2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SignedExchangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SignedExchangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SignedExchangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SignedExchangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ExchangeResponse.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getResponsev2();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ExchangeResponseV2.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExchangeResponse response = 1;
 * @return {?proto.ExchangeResponse}
 */
proto.SignedExchangeResponse.prototype.getResponse = function() {
  return /** @type{?proto.ExchangeResponse} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeResponse, 1));
};


/** @param {?proto.ExchangeResponse|undefined} value */
proto.SignedExchangeResponse.prototype.setResponse = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.SignedExchangeResponse.prototype.clearResponse = function() {
  this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.SignedExchangeResponse.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */
proto.SignedExchangeResponse.prototype.getSignature = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */
proto.SignedExchangeResponse.prototype.getSignature_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSignature()));
};


/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */
proto.SignedExchangeResponse.prototype.getSignature_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSignature()));
};


/** @param {!(string|Uint8Array)} value */
proto.SignedExchangeResponse.prototype.setSignature = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.SignedExchangeResponse.prototype.clearSignature = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.SignedExchangeResponse.prototype.hasSignature = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ExchangeResponseV2 responseV2 = 3;
 * @return {?proto.ExchangeResponseV2}
 */
proto.SignedExchangeResponse.prototype.getResponsev2 = function() {
  return /** @type{?proto.ExchangeResponseV2} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeResponseV2, 3));
};


/** @param {?proto.ExchangeResponseV2|undefined} value */
proto.SignedExchangeResponse.prototype.setResponsev2 = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.SignedExchangeResponse.prototype.clearResponsev2 = function() {
  this.setResponsev2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.SignedExchangeResponse.prototype.hasResponsev2 = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ExchangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ExchangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ExchangeResponse.displayName = 'proto.ExchangeResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ExchangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ExchangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ExchangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    depositAddress: (f = msg.getDepositAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    depositAmount: jspb.Message.getField(msg, 2),
    expiration: jspb.Message.getField(msg, 3),
    quotedRate: jspb.Message.getField(msg, 4),
    withdrawalAddress: (f = msg.getWithdrawalAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    withdrawalAmount: jspb.Message.getField(msg, 6),
    returnAddress: (f = msg.getReturnAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
    apiKey: msg.getApiKey_asB64(),
    minerFee: jspb.Message.getField(msg, 9),
    orderId: msg.getOrderId_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ExchangeResponse}
 */
proto.ExchangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ExchangeResponse;
  return proto.ExchangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ExchangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ExchangeResponse}
 */
proto.ExchangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setDepositAddress(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDepositAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiration(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setQuotedRate(value);
      break;
    case 5:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setWithdrawalAddress(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWithdrawalAmount(value);
      break;
    case 7:
      var value = new proto.ExchangeAddress;
      reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
      msg.setReturnAddress(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setApiKey(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMinerFee(value);
      break;
    case 10:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ExchangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ExchangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ExchangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExchangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDepositAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getWithdrawalAddress();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getReturnAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ExchangeAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBytes(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBytes(
      10,
      f
    );
  }
};


/**
 * optional ExchangeAddress deposit_address = 1;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponse.prototype.getDepositAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 1));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponse.prototype.setDepositAddress = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.ExchangeResponse.prototype.clearDepositAddress = function() {
  this.setDepositAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasDepositAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 deposit_amount = 2;
 * @return {number}
 */
proto.ExchangeResponse.prototype.getDepositAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.ExchangeResponse.prototype.setDepositAmount = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.ExchangeResponse.prototype.clearDepositAmount = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasDepositAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 expiration = 3;
 * @return {number}
 */
proto.ExchangeResponse.prototype.getExpiration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.ExchangeResponse.prototype.setExpiration = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.ExchangeResponse.prototype.clearExpiration = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasExpiration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 quoted_rate = 4;
 * @return {number}
 */
proto.ExchangeResponse.prototype.getQuotedRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.ExchangeResponse.prototype.setQuotedRate = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.ExchangeResponse.prototype.clearQuotedRate = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasQuotedRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ExchangeAddress withdrawal_address = 5;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponse.prototype.getWithdrawalAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 5));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponse.prototype.setWithdrawalAddress = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.ExchangeResponse.prototype.clearWithdrawalAddress = function() {
  this.setWithdrawalAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasWithdrawalAddress = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 withdrawal_amount = 6;
 * @return {number}
 */
proto.ExchangeResponse.prototype.getWithdrawalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.ExchangeResponse.prototype.setWithdrawalAmount = function(value) {
  jspb.Message.setField(this, 6, value);
};


proto.ExchangeResponse.prototype.clearWithdrawalAmount = function() {
  jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasWithdrawalAmount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ExchangeAddress return_address = 7;
 * @return {?proto.ExchangeAddress}
 */
proto.ExchangeResponse.prototype.getReturnAddress = function() {
  return /** @type{?proto.ExchangeAddress} */ (
    jspb.Message.getWrapperField(this, proto.ExchangeAddress, 7));
};


/** @param {?proto.ExchangeAddress|undefined} value */
proto.ExchangeResponse.prototype.setReturnAddress = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.ExchangeResponse.prototype.clearReturnAddress = function() {
  this.setReturnAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasReturnAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bytes api_key = 8;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponse.prototype.getApiKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * optional bytes api_key = 8;
 * This is a type-conversion wrapper around `getApiKey()`
 * @return {string}
 */
proto.ExchangeResponse.prototype.getApiKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getApiKey()));
};


/**
 * optional bytes api_key = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getApiKey()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponse.prototype.getApiKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getApiKey()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponse.prototype.setApiKey = function(value) {
  jspb.Message.setField(this, 8, value);
};


proto.ExchangeResponse.prototype.clearApiKey = function() {
  jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasApiKey = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 miner_fee = 9;
 * @return {number}
 */
proto.ExchangeResponse.prototype.getMinerFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.ExchangeResponse.prototype.setMinerFee = function(value) {
  jspb.Message.setField(this, 9, value);
};


proto.ExchangeResponse.prototype.clearMinerFee = function() {
  jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasMinerFee = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bytes order_id = 10;
 * @return {!(string|Uint8Array)}
 */
proto.ExchangeResponse.prototype.getOrderId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * optional bytes order_id = 10;
 * This is a type-conversion wrapper around `getOrderId()`
 * @return {string}
 */
proto.ExchangeResponse.prototype.getOrderId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getOrderId()));
};


/**
 * optional bytes order_id = 10;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOrderId()`
 * @return {!Uint8Array}
 */
proto.ExchangeResponse.prototype.getOrderId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getOrderId()));
};


/** @param {!(string|Uint8Array)} value */
proto.ExchangeResponse.prototype.setOrderId = function(value) {
  jspb.Message.setField(this, 10, value);
};


proto.ExchangeResponse.prototype.clearOrderId = function() {
  jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ExchangeResponse.prototype.hasOrderId = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto);
